// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n[data-v-7bf279f0] .delete-classification.disabled {\n  cursor: default !important;\n}\n[data-v-7bf279f0] .delete-classification.disabled span {\n  display: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
